/**
 * REDUX CONSTANTS
 * Redux action types used in payments-js must be namespaced as they may clash
 * with other action types used throughout the host app (rental-manager-web).
 */

const getLandlordRequestActionTypes = (requestName) => ({
  INIT: `PAYMENTS/LANDLORD/${requestName}_INIT`,
  SUCCESS: `PAYMENTS/LANDLORD/${requestName}_SUCCESS`,
  FAIL: `PAYMENTS/LANDLORD/${requestName}_FAIL`,
});

// request action types
export const REQUEST_USER_API = getLandlordRequestActionTypes('REQUEST_USER_API');
export const REQUEST_LANDLORD_STATUS = getLandlordRequestActionTypes('REQUEST_LANDLORD_STATUS');
export const REQUEST_LANDLORD_STATUS_SETUP_NEW_TERM = getLandlordRequestActionTypes(
  'REQUEST_LANDLORD_STATUS_SETUP_NEW_TERM',
);
export const REQUEST_LINK_TOKEN = getLandlordRequestActionTypes('REQUEST_LINK_TOKEN');
export const REQUEST_VERIFY_IDENTITY = getLandlordRequestActionTypes('REQUEST_VERIFY_IDENTITY');
export const REQUEST_LANDLORD_ID_UPLOAD = getLandlordRequestActionTypes('REQUEST_LANDLORD_ID_UPLOAD');
export const REQUEST_UPDATE_TENANT = getLandlordRequestActionTypes('REQUEST_UPDATE_TENANT');
export const REQUEST_RENT_AMOUNT_CHANGE = getLandlordRequestActionTypes('REQUEST_RENT_AMOUNT_CHANGE');
export const REQUEST_CANCEL_RENT_AMOUNT_CHANGE = getLandlordRequestActionTypes('REQUEST_CANCEL_RENT_AMOUNT_CHANGE');
export const REQUEST_SEND_NOTIFICATION = getLandlordRequestActionTypes('REQUEST_SEND_NOTIFICATION');
export const REQUEST_STOP_PAYMENTS = getLandlordRequestActionTypes('REQUEST_STOP_PAYMENTS');
export const REQUEST_CREATE_ONE_TIME_PAYMENT = getLandlordRequestActionTypes('REQUEST_CREATE_ONE_TIME_PAYMENT');
export const REQUEST_CREATE_PAYMENT_PLAN_INSTALLMENT = getLandlordRequestActionTypes(
  'REQUEST_CREATE_PAYMENT_PLAN_INSTALLMENT',
);
export const REQUEST_CREATE_MOVE_IN_COSTS = getLandlordRequestActionTypes('REQUEST_CREATE_MOVE_IN_COSTS');
export const REQUEST_DELETE_ONE_TIME_PAYMENT = getLandlordRequestActionTypes('REQUEST_DELETE_ONE_TIME_PAYMENT');
export const REQUEST_DELETE_PAYMENT_PLAN = getLandlordRequestActionTypes('REQUEST_DELETE_PAYMENT_PLAN');
export const REQUEST_CANCEL_MOVE_IN_COSTS = getLandlordRequestActionTypes('REQUEST_CANCEL_MOVE_IN_COSTS');
export const REQUEST_PHONE_VERIFICATION_CHECK = getLandlordRequestActionTypes('REQUEST_PHONE_VERIFICATION_CHECK');
export const REQUEST_PHONE_VERIFICATION_SEND = getLandlordRequestActionTypes('REQUEST_PHONE_VERIFICATION_SEND');
export const REQUEST_PHONE_VERIFICATION_CONFIRM = getLandlordRequestActionTypes('REQUEST_PHONE_VERIFICATION_CONFIRM');
export const REQUEST_SUBMIT_FEEDBACK = getLandlordRequestActionTypes('REQUEST_SUBMIT_FEEDBACK');
export const REQUEST_MARK_ACKNOWLEDGED = getLandlordRequestActionTypes('REQUEST_MARK_ACKNOWLEDGED');
export const REQUEST_ID_VERIFICATION_QUESTIONS = getLandlordRequestActionTypes('REQUEST_ID_VERIFICATION_QUESTIONS');
export const REQUEST_SUBMIT_ID_VERIFICATION_ANSWERS = getLandlordRequestActionTypes(
  'REQUEST_SUBMIT_ID_VERIFICATION_ANSWERS',
);
export const REQUEST_GET_FEATURE_PERMISSIONS = getLandlordRequestActionTypes('REQUEST_GET_FEATURE_PERMISSIONS');
export const REQUEST_GET_ID_VERIFICATION_INFO = getLandlordRequestActionTypes('REQUEST_GET_ID_VERIFICATION_INFO');
export const REQUEST_CREATE_RENT_TERMS = getLandlordRequestActionTypes('REQUEST_CREATE_RENT_TERMS');
export const REQUEST_UPDATE_RENT_TERMS = getLandlordRequestActionTypes('REQUEST_UPDATE_RENT_TERMS');

export const REQUEST_EMBEDDED_COVERAGE_REQUEST_URL = getLandlordRequestActionTypes(
  'REQUEST_EMBEDDED_COVERAGE_REQUEST_URL',
);
export const REQUEST_MARK_COVERAGE_REQUEST_SIGNED = getLandlordRequestActionTypes(
  'REQUEST_MARK_COVERAGE_REQUEST_SIGNED',
);
export const REQUEST_COVERAGE_REQUEST_SIGNING_CANCELLED = getLandlordRequestActionTypes(
  'REQUEST_COVERAGE_REQUEST_SIGNING_CANCELLED',
);
export const REQUEST_RENTAL_PROTECTION_LEGAL_DISCLAIMER = getLandlordRequestActionTypes(
  'REQUEST_RENTAL_PROTECTION_LEGAL_DISCLAIMER',
);
export const REQUEST_SAVE_RENTAL_RELATIONSHIP_ID_TO_POLICY = getLandlordRequestActionTypes(
  'REQUEST_SAVE_RENTAL_RELATIONSHIP_ID_TO_POLICY',
);
export const REQUEST_GET_USER_ADDRESS = getLandlordRequestActionTypes('REQUEST_GET_USER_ADDRESS');
export const REQUEST_SET_USER_ADDRESS = getLandlordRequestActionTypes('REQUEST_SET_USER_ADDRESS');
export const REQUEST_VERIFY_ADDRESS = getLandlordRequestActionTypes('REQUEST_VERIFY_ADDRESS');
export const REQUEST_HOSTED_ONBOARDING_URL = getLandlordRequestActionTypes('REQUEST_HOSTED_ONBOARDING_URL');
export const REQUEST_PHONE_NUMBER_FROM_LISTING = getLandlordRequestActionTypes('REQUEST_PHONE_NUMBER_FROM_LISTING');

// non-request action types
export const ACCEPT_TERMS = 'PAYMENTS/LANDLORD/ONBOARDING/ACCEPT_TERMS';
export const SAVE_ENCODED_LEASE_ID = 'PAYMENTS/LANDLORD/ONBOARDING/SAVE_ENCODED_LEASE_ID';
export const COLLECT_MOVE_IN_COSTS = 'PAYMENTS/LANDLORD/ONBOARDING/COLLECT_MOVE_IN_COSTS';
export const SAVE_MOVE_IN_COST_SETTINGS = 'PAYMENTS/LANDLORD/ONBOARDING/SAVE_MOVE_IN_COST_SETTINGS';
export const SAVE_PAYMENT_SETTINGS = 'PAYMENTS/LANDLORD/ONBOARDING/SAVE_PAYMENT_SETTINGS';
export const SAVE_ACCOUNT_INFO = 'PAYMENTS/LANDLORD/ONBOARDING/SAVE_ACCOUNT_INFO';
export const SAVE_IDENTITY_VERIFICATION = 'PAYMENTS/LANDLORD/ONBOARDING/SAVE_IDENTITY_VERIFICATION';
export const SAVE_EXPERIAN_ERROR_STATE = 'PAYMENTS/LANDLORD/ONBOARDING/SAVE_EXPERIAN_ERROR_STATE';
export const SAVE_INVITE_TENANT = 'PAYMENTS/LANDLORD/ONBOARDING/SAVE_INVITE_TENANT';
export const EDIT_PAYMENT_SETTINGS = 'PAYMENTS/LANDLORD/ONBOARDING/EDIT_PAYMENT_SETTINGS';
export const EDIT_RENT_AMOUNT = 'PAYMENTS/LANDLORD/ONBOARDING/EDIT_RENT_AMOUNT';
export const EDIT_DUE_DATE = 'PAYMENTS/LANDLORD/ONBOARDING/EDIT_DUE_DATE';
export const EDIT_PAYMENT_TERM = 'PAYMENTS/LANDLORD/ONBOARDING/EDIT_PAYMENT_TERM';
export const EDIT_MOVE_IN_COSTS = 'PAYMENTS/LANDLORD/ONBOARDING/EDIT_MOVE_IN_COSTS';
export const EDIT_ACCOUNT_INFO = 'PAYMENTS/LANDLORD/ONBOARDING/EDIT_ACCOUNT_INFO';
export const EDIT_TAX_VERIFICATION = 'PAYMENTS/LANDLORD/ONBOARDING/EDIT_TAX_VERIFICATION';
export const EDIT_INVITE_TENANT = 'PAYMENTS/LANDLORD/ONBOARDING/EDIT_INVITE_TENANT';
export const START_NEW_TERM = 'PAYMENTS/LANDLORD/NEW_TERM/START';
export const SAVE_ONE_TIME_PAYMENT_REQUEST = 'PAYMENTS/LANDLORD/DASHBOARD/SAVE_ONE_TIME_PAYMENT_REQUEST';
export const RESET_ONE_TIME_PAYMENT_REQUEST = 'PAYMENTS/LANDLORD/DASHBOARD/RESET_ONE_TIME_PAYMENT_REQUEST';
export const SETUP_NEW_TERM = 'PAYMENTS/LANDLORD/SETUP_NEW_TERM';
export const EDITING_RENT_TERMS = 'PAYMENTS/LANDLORD/DASHBOARD/EDITING_RENT_TERMS';
export const EDITING_MOVE_IN_COSTS = 'PAYMENTS/LANDLORD/DASHBOARD/EDITING_MOVE_IN_COSTS';
export const SAVE_LEASE_ID = 'PAYMENTS/LANDLORD/DASHBOARD/SAVE_LEASE_ID';
export const SAVE_RENTAL_PROTECTION_FEATURE = 'PAYMENTS/LANDLORD/ONBOARDING/SAVE_RENTAL_PROTECTION_FEATURE';
export const SAVE_LISTING_ALIAS = 'PAYMENTS/LANDLORD/SAVE_LISTING_ALIAS';
export const SAVE_LISTING_DETAILS = 'PAYMENTS/LANDLORD/SAVE_LISTING_DETAILS';
export const SAVE_NEW_TERM_SETTINGS = 'PAYMENTS/LANDLORD/DASHBOARD/SAVE_NEW_TERM_SETTINGS';
export const RESET_NEW_TERM_SETTINGS = 'PAYMENTS/LANDLORD/DASHBOARD/RESET_NEW_TERM_SETTINGS';
